import React from 'react';

import Box from '../Box/Box';

import type { TInlineSwitch, TSwitchInput } from './@types/TSwitch';
import componentName from './name';
import { isEnterOrSpace } from '../../utils/keyboard';

const SwitchInput = ({ isOn, onChange, value, id }: TSwitchInput) => (
  <Box
    as="input"
    type="checkbox"
    checked={isOn}
    onChange={onChange}
    parent={componentName}
    name="Input"
    value={value}
    id={id}
    aria-hidden="true"
  />
);

const InlineSwitch = ({
  onChange,
  isOn = false,
  value,
  children,
  ariaLabelledBy,
  ariaDescribedBy,
  isCompound,
  inputId,
  ...rest
}: TInlineSwitch) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (!isEnterOrSpace(event.key)) return;
    onChange?.(event);
    event.preventDefault();
  };

  const getModifiers = () => {
    const modifiers: string[] = isOn ? ['on'] : [];
    if (!isCompound) modifiers.push('Inline');
    return modifiers;
  };

  return (
    <Box as="label" name={componentName} modifiers={getModifiers()} {...rest}>
      <SwitchInput isOn={isOn} onChange={onChange} value={value} id={inputId} />

      {children}

      <Box
        as="div"
        parent={componentName}
        name="Button"
        tabIndex={0}
        onKeyDown={handleKeyDown}
        role="switch"
        aria-checked={isOn}
        aria-labelledby={ariaLabelledBy}
        aria-describedby={ariaDescribedBy}
      >
        <Box as="div" parent={componentName} name="Handle" />
      </Box>
    </Box>
  );
};

export default InlineSwitch;
